export default __webpack_public_path__ + "static/20251031-e455ad7f1f84dfe6378ea7765993c097.png";